import { Model, BelongsTo, Attr } from 'spraypaint';

import { ApplicationRecord } from './application_record';
import ChefPackage from './chef_package';

@Model()
export default class ChefPackagePresignedUrl extends ApplicationRecord {
  static jsonapiType = 'chef_package_presigned_urls';

  @Attr() url: string;
  @Attr() readOnly: boolean;
  @Attr() downloadUrl: string;
  @Attr() headers: object;

  @BelongsTo() chefPackage: ChefPackage;
}
